export default {
  svgData: [
    {
      id: "slide1tv",
      name: "TV",
      label: "slide1tv"
    },
    {
      id: "slide1easel1",
      name: "Easel",
      assets: [""],
      label: "slide1easel1"
    },
    {
      id: "slide1display1",
      name: "Display 1",
      assets: [
        "https://cdn.scoutfeedback.com/gdot-workshop/eic/welcome/Public+Involvement+Handout+v7_Page_1.jpg",
        "https://cdn.scoutfeedback.com/gdot-workshop/eic/welcome/Public+Involvement+Handout+v7_Page_2.jpg",
        "https://cdn.scoutfeedback.com/gdot-workshop/eic/welcome/Public+Involvement+Handout+v7_Page_3.jpg",
        "https://cdn.scoutfeedback.com/gdot-workshop/eic/welcome/Public+Involvement+Handout+v7_Page_4.jpg",
        "https://cdn.scoutfeedback.com/gdot-workshop/eic/welcome/Public+Involvement+Handout+v7_Page_5.jpg",
        "https://cdn.scoutfeedback.com/gdot-workshop/eic/welcome/Public+Involvement+Handout+v7_Page_6.jpg",
      ],
      label: "slide1display1"
    },
    {
      id: "slide1display2",
      name: "Display 2",
      assets: [
        "https://cdn.scoutfeedback.com/gdot-workshop/eic/welcome/West+Interchange+Fact+Sheet_31.jpg"
      ],
      label: "slide1display2"
    },
    {
      id: "slide1display3",
      name: "Display 3",
      assets: [
        "https://cdn.scoutfeedback.com/gdot-workshop/eic/welcome/I-285+West+Interchange+FAQ_22_Page_1.jpg",
        "https://cdn.scoutfeedback.com/gdot-workshop/eic/welcome/I-285+West+Interchange+FAQ_22_Page_2.jpg",
      ],
      label: "slide1display3"
    },
    {
      id: "slide1avatar1"
    }
  ],
  slideTitle: "Welcome",
  aboutText: `
    <p class="text-justify help">
    This virtual meeting room showcases project information that has been updated or changed since the Public Information Open House series hosted in late 2019. Here you can view different stations or spaces that include handouts, environmental documents, displays, proposed project concept, updated fly-through visualization of the project, and the opportunity to submit public comment.    </p>
    <p class="text-justify help">
    The Welcome station includes a <b><u>Welcome Video</u></b> from Georgia DOT staff, and documents on the table include the <b><u>Information Handout, Fact Sheet</b></u>, and <b><u>FAQ</b></u>. The easel to the right is a Project Overview Display that includes the Project Map, Need and Purpose, Project Schedule, and a map of the other projects that are part of the Major Mobility Investment Program (MMIP). 
    </p>
    <p class="text-justify help">
    If you have any questions, please feel free to contact us. 
    </p>
    <p class="text-justify help">
    Email: <a href="mailto:eastinterchange@dot.ga.gov">eastinterchange@dot.ga.gov</a>    
    </p>
    <p class="text-justify help">
    Phone: (470) 407-9167
    </p>
  `,
  helpText: `
    <p class="text-justify help">
    Thank you for joining our interactive I-285/I-20 East Interchange Project (PI# 0013915) virtual meeting room hosted by the Georgia Department of Transportation (Georgia DOT). In keeping with Governor Kemp’s directive to keep essential state government agencies functioning as Georgia combats the COVID-19 pandemic, Georgia DOT has placed updated project information on an online platform in compliance with social distancing guidelines to avoid large gatherings. The online platform and interactive virtual meeting room houses the same project information that you would find at an in-person Public Hearing Open House (PHOH) for the project.     </p>
    <p class="text-justify help">
    The comment period for the Draft Environmental Assessment (EA) ended on Thursday, September 24, 2020. An official PHOH Comment Response document is being prepared and when available will be posted on the <a href="https://majormobilityga.com/projects/eastsideic/" target="_blank">project web page</a> in the <a href="https://majormobilityga.com/projects/eastsideic/document-library/" target="_blank">Document Library</a>. You may continue to view the displays in this virtual meeting room space that were created in support of the Draft EA and the project’s <a href="https://0013915-gdot.hub.arcgis.com/" target="_blank">public involvement website</a>.
    </p>
    <p class="text-justify help">
    Before you enter each station or space of the virtual meeting room, you will receive a pop-up message detailing what resources and specific information are available to you. <b>We encourage you to click on the virtual staff members and assets that are labeled to learn more about the project. Click the following button <i class="mdi mdi-account-question" style="font-size:2em;"></i> to learn about the specific station or the <i class="mdi mdi-information-outline" style="font-size:2em;"></i> to see this message again after you close it out.</b> To navigate to a new station or space, click the left or right arrow or select your station of choice from the sidebar on the right.
    </p>
    <p class="text-justify help">
    Now, in this first station, we recommend the following actions to help you learn more about the proposed I-285/I-20 East Interchange Project: 
    </p>
    <ul class="text-justify help">
      <li>      
      Watch the <b><u>Welcome Video</u></b> to become more familiar with our interactive, virtual meeting room. 
      </li>
      <br>
      <li>
      Click the documents on the table to review the project’s <b><u>Information Handout</u></b>, <b><u>Fact Sheet</u></b>, and <b><u>FAQ</u></b>. 
      </li>
      <br>
      <li>
      Click the <b><u>Project Overview Displays</u></b> on the easel to view the Project Map, Need and Purpose, Project Schedule, and map of the other projects that are part of the Major Mobility Investment Program (MMIP). 
      </li>
    </ul>
    <br>
    <p class="text-justify help">
    Once your tour of the Welcome space is complete, we invite you to visit the next station by clicking on the right arrow or selecting your station of choice from the sidebar on the right. 
    </p>
     `
};
